<ng-container *ngIf="initialized">

<!--    <p-tabMenu [model]="tabItems" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>-->

    <p-tabs [(value)]="tabIndex" (valueChange)="onActiveItemChange($event)">
        <p-tablist>
            @for(item of tabItems; track item) {
                <p-tab [value]="item.id">{{ item.label }}</p-tab>
            }
        </p-tablist>
    </p-tabs>

    <ng-container *ngIf="activeItem.id == 'ci.ContractPerson'">
        <mvs-widget
                *ngIf="widgetContractPerson"
                [widgetData]="widgetContractPerson"
        ></mvs-widget>
    </ng-container>

    <ng-container *ngIf="activeItem.id == 'pm.Person'">

        <br />

        <mvs-object
            objectType="pm.Person"
            [objectId]="dto.personDtoId"
        ></mvs-object>

    </ng-container>

</ng-container>